import { TOOLTIP_STEPS, TOnboardingStep } from "../../../utils/constant";

export const simulateSteps: TOnboardingStep[] = [
  {
    step: TOOLTIP_STEPS.SELECT_PROCEDURE,
    title: "Select a Procedure",
    text: "Choose a procedure to simulate.",
    next: TOOLTIP_STEPS.SELECT_MODEL,
  },
  {
    step: TOOLTIP_STEPS.SELECT_MODEL,
    title: "Select a Model",
    text: "Pick or upload a patient image.",
    next: TOOLTIP_STEPS.SELECT_SECOND_PROCEDURE,
  },
  {
    step: TOOLTIP_STEPS.SELECT_SECOND_PROCEDURE,
    title: "Try Another Procedure",
    text: "Now try simulating a different one.",
    next: TOOLTIP_STEPS.SIMULATION_TIPS_COMPLETED,
  },
];

export const beforeAfterSteps: TOnboardingStep[] = [
  {
    step: TOOLTIP_STEPS.START_BEFORE_AFTER,
    title: "Welcome to Before & After",
    text: "Get started by uploading your first images.",
    next: TOOLTIP_STEPS.USE_PLACEHOLDER_IMAGES,
  },
  {
    step: TOOLTIP_STEPS.USE_PLACEHOLDER_IMAGES,
    title: "Use Sample Images",
    text: "Try it out with our built-in samples.",
    next: TOOLTIP_STEPS.USE_AI_SETTINGS,
  },
  {
    step: TOOLTIP_STEPS.USE_AI_SETTINGS,
    title: "Customize with AI",
    text: "Fine-tune crop, align, and match settings.",
    next: TOOLTIP_STEPS.GENERATE_IMAGES,
  },
  {
    step: TOOLTIP_STEPS.GENERATE_IMAGES,
    title: "Generate Images",
    text: "Click here to generate your before-after images.",
    next: TOOLTIP_STEPS.EDIT_TEMPLATE,
  },
  {
    step: TOOLTIP_STEPS.EDIT_TEMPLATE,
    title: "Edit Your Template",
    text: "Make adjustments to your before-after template.",
    next: TOOLTIP_STEPS.ADD_TEXT_OR_IMAGES,
  },
  {
    step: TOOLTIP_STEPS.ADD_TEXT_OR_IMAGES,
    title: "Add Text or Images",
    text: "Enhance your template with additional elements.",
    next: TOOLTIP_STEPS.CONTINUE_TO_BEFORE_AFTER_RESULTS,
  },
  {
    step: TOOLTIP_STEPS.CONTINUE_TO_BEFORE_AFTER_RESULTS,
    title: "Continue to Before & After Results",
    text: "Click here to proceed to the results.",
    next: TOOLTIP_STEPS.ADJUST_IMAGES,
  },
  {
    step: TOOLTIP_STEPS.ADJUST_IMAGES,
    title: "Adjust Images",
    text: "Fine-tune the positioning of your images.",
    next: TOOLTIP_STEPS.SWAP_IMAGES,
  },
  {
    step: TOOLTIP_STEPS.SWAP_IMAGES,
    title: "Swap Images",
    text: "Switch the positions of your images.",
    next: TOOLTIP_STEPS.SAVE_CHANGES,
  },
  {
    step: TOOLTIP_STEPS.SAVE_CHANGES,
    title: "Save Your Changes",
    text: "Click here to save your template.",
    next: TOOLTIP_STEPS.DOWNLOAD_IMAGES,
  },
  {
    step: TOOLTIP_STEPS.DOWNLOAD_IMAGES,
    title: "Download Your Images",
    text: "Get your final before-after images.",
    next: TOOLTIP_STEPS.BEFORE_AFTER_TIPS_COMPLETED,
  },
];

export const consultSteps: TOnboardingStep[] = [
  {
    step: TOOLTIP_STEPS.START_CONSULT,
    title: "Welcome to Consults",
    text: "Press 'Switch to Week View' to view all appointments.",
    next: TOOLTIP_STEPS.SWITCH_VIEW,
  },
  {
    step: TOOLTIP_STEPS.SWITCH_VIEW,
    title: "Select an Appointment",
    text: "Tap on one of today's consults.",
    next: TOOLTIP_STEPS.SELECT_APPOINTMENT,
  },
  {
    step: TOOLTIP_STEPS.SELECT_APPOINTMENT,
    title: "Select an Appointment",
    text: "Choose a patient to begin the consultation workflow.",
    next: TOOLTIP_STEPS.VIEW_APPOINTMENT_DETAIL,
  },
  {
    step: TOOLTIP_STEPS.VIEW_APPOINTMENT_DETAIL,
    title: "View Patient Snapshot",
    text: "See appointment notes, images, and intake info in one place.",
    next: TOOLTIP_STEPS.RECORD_CONSULT,
  },
  {
    step: TOOLTIP_STEPS.RECORD_CONSULT,
    title: "Record the Conversation",
    text: "Tap record to capture, transcribe, and summarize the consult.",
    next: TOOLTIP_STEPS.VIEW_TRANSCRIPT,
  },
  {
    step: TOOLTIP_STEPS.VIEW_TRANSCRIPT,
    title: "Review the Transcript",
    text: "Check the AI-generated summary and transcript of the consult.",
    next: TOOLTIP_STEPS.SELECT_IMAGE_TO_SIMULATE,
  },
  {
    step: TOOLTIP_STEPS.SELECT_IMAGE_TO_SIMULATE,
    title: "Select an Image to Simulate",
    text: "Choose a patient image to simulate procedures.",
    next: TOOLTIP_STEPS.SIMULATE_IN_CONSULT,
  },
  {
    step: TOOLTIP_STEPS.SIMULATE_IN_CONSULT,
    title: "Try a Simulation",
    text: "Pick a patient image and show them a realistic preview.",
    next: TOOLTIP_STEPS.CONSULT_TIPS_COMPLETED,
  },
];
